import { Component, OnDestroy, OnInit } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Organization } from "../../common/models/organization";
import { Athlete } from "../../common/models/athlete";
import { Timeslot } from '../../common/models/timeslot';
import { Session } from '../../common/models/session';
import { User } from "../../common/models/user";
import { MobilePageContentComponent } from "../../common/components/mobile-page-content/mobile-page-content";
import { MobileHeaderComponent } from "../../common/components/mobile-header/mobile.header";
import { MobileSideMenuComponent } from "../../common/components/mobile-side-menu/mobile.side-menu.component";
import { ModuleContentComponent } from "../../common/components/module-content/module-content";
import { MatButton, MatButtonModule } from "@angular/material/button";
import { MobileSessionViewComponent } from "./session-view/mobile.session-view.component";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: 'app-mobile-diary-show',
  styleUrls: ['./mobile.diary-show.component.scss'],
  standalone: true,
  imports: [
    MobilePageContentComponent,
    MobileHeaderComponent,
    MobileSideMenuComponent,
    ModuleContentComponent,
    MatButtonModule,
    MobileSessionViewComponent,
    TranslateModule
  ],
  templateUrl: './mobile.diary-show.component.html'
})
export class MobileDiaryShowComponent implements OnInit, OnDestroy {

    public organization: Organization = {} as Organization;
    public athleteUser: User = {} as User;
    public session: Session = {} as Session;
    public timeSlot: Timeslot = {} as Timeslot;
    public sessionEndEnabled = false;

    private subscriptions: Subscription[] = [];

    constructor(
        private route: ActivatedRoute,
        private router: Router
    ) {

    }

    public ngOnInit(): void {
        this.subscriptions.push(
            this.route.data.subscribe((data: any) => { //{ organization: Organization; athlete: Athlete; session: Session; timeSlot: Timeslot }
                this.organization = data.organization;
                this.athleteUser = data.athlete;
                this.session = data.session;
                this.timeSlot = data.timeSlot;

                this.sessionEndEnabled = true;
            })
        );
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }

    public onFeedbackNewClicked(): void {
        this.router.navigate([this.organization!.code, 'app', 'athletes', this.athleteUser.id, 'feedback', 'session', 'timeslot', this.timeSlot.id, 'new']);
    }
}
